import React, { useEffect, useState } from 'react';
import Carousel from '@componentsV2/Carousel';
import {
  StyledCarouselContent,
  StyledCarouselWrapper,
} from '@componentsV2/CarouselHomeSection/styles';
import { useSanityContent } from '@hooksV2/useSanityContent';
import { OverviewGridItem } from '../../views/PrivateRoutes/Dashboard/Home/Overview/components';
import { getImageKitImageUrlForSanity } from '../../content/contentHelpers';
import matomo from '../../utils/matomo';
import { looksLikeUrl } from '../../utils/looksLikeUrl';
import useDashboardLinkPrefix from '../../hooks/useDashboardLinkPrefix';

const CarouselHomeSection = ({ annonseLabel = false }) => {
  const sanityData = useSanityContent();
  const dashboardLinkPrefix = useDashboardLinkPrefix();

  const [vendorAdvertisementSliderData, setVendorAdvertisementSliderData] =
    useState([]);

  const buildUrl = (urlOrPath) => {
    if (looksLikeUrl(urlOrPath)) {
      return urlOrPath;
    }
    return dashboardLinkPrefix + urlOrPath;
  };

  const trackCarouselNavigation = (index) => {
    matomo.clickEvent({
      category: 'Vendor Advertisement',
      name: `Vendor Advertisement Slide ${index} is shown`,
      action: `User Swiped to ${index} slide`,
    });
  };

  const trackCarouselLink = (url) => {
    const hiddenBoligmappaNumber = url.replace(
      /\/dashboard\/[^/]+/,
      '/dashboard/{boligmappaNumber}'
    );
    matomo.clickEvent({
      category: 'Vendor Advertisement',
      name: `Vendor Advertisement See more button clicked`,
      action: `Open new tab with link ${hiddenBoligmappaNumber}`,
    });
  };

  useEffect(() => {
    setVendorAdvertisementSliderData(sanityData.vendorAdvertisementSlider);
    matomo.clickEvent({
      category: 'Vendor Advertisement',
      name: `Vendor Advertisement Carousel is rendered`,
      action: `Vendor Advertisement Carousel is rendered`,
    });
  }, []);

  const renderedCarouselItems = (items) =>
    items.map((item) => (
      <StyledCarouselContent>
        <h2>{item.title}</h2>
        <img
          height="45"
          className="logo"
          alt="Company logo"
          src={getImageKitImageUrlForSanity(item.slideLogo.asset, 300)}
        />
        {item.headline && <h3>{item.headline}</h3>}
        <p>{item.paragraph}</p>
      </StyledCarouselContent>
    ));
  return (
    <OverviewGridItem>
      <StyledCarouselWrapper>
        <span className="corner_label">Partnersamarbeid</span>
        {vendorAdvertisementSliderData.length > 0 && (
          <Carousel
            showLink
            autoSlide={15}
            startSlide={Math.floor(
              Math.random() * vendorAdvertisementSliderData.length
            )}
            onCarouselNavigation={trackCarouselNavigation}
            onLinkClick={trackCarouselLink}
            linkText="Les mer"
            buttonTexts={vendorAdvertisementSliderData.map(
              (el) => el.ctaButtonText
            )}
            buttonUrls={vendorAdvertisementSliderData.map((el) =>
              buildUrl(el.link)
            )}
            items={renderedCarouselItems(vendorAdvertisementSliderData)}
          />
        )}
        {annonseLabel && <span className="annonse_label">annonse</span>}
      </StyledCarouselWrapper>
    </OverviewGridItem>
  );
};

export default CarouselHomeSection;
